angular
    .module('app')
    .component('winbackStateOffersList', {
        templateUrl: '/templates/pages/winback-state-offers/winback-state-offers-list/winback-state-offers-list.html',
        controller: 'WinbackStateOffersListController',
        controllerAs: 'vm',
    });